<template>
  <div class="ba-targeting-values"
       :class="{'is-only-one-value': numSelectedVisibleOptions < 2}">
      <span v-if="visibleOptions.session"
            class="item session" :class="{'invalid-value': nodeData.sessCntIsInaccurate}">
        <i class="icon icon--ba-session-small"></i>
        {{ getComputedSessCnt | letterThousandMillion(0) }}
      </span>
      <span v-if="isForwardDirection && visibleOptions.dropOff"
            class="item dropoff">
        <i class="icon icon--dropoff-2"></i>
        {{ nodeData.dropOff | fixedInt(2, 1) }}%
      </span>
      <span v-if="visibleOptions.nullity"
            class="item nullity">
        <i class="icon icon--nullity"></i>
        {{ getPercentage(nodeData.nullity) }}
      </span>
      <span v-if="visibleOptions.refresh"
            class="item refresh">
        <i class="icon icon--refresh"></i>
        {{ getPercentage(nodeData.repeat) }}
      </span>
      <span v-if="visibleOptions.duration"
            class="item duration">
        <i class="icon icon--hourglass-1"></i>
        {{ timeString }}
      </span>
  </div>
</template>

<script>
import { getTimeString } from '@/libs/utils'
import { mapState } from 'vuex'

export default {
  name: 'BaTargetingNodeValues',
  components: {
  },
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    visibleOptions: {
      type: Object,
      required: true
    },
    numSelectedVisibleOptions: {
      type: Number,
      default: 0
    },
    isForwardDirection: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'originJourneyData',
      'domain',
      'journeyOptions',
      'isSampling'
    ]),
    isSurvey () {
      return this.journeyOptions.survey
    },
    getComputedSessCnt () {
      return this.nodeData.sessCntIsInaccurate ? this.$t('common.invalidValue') : this.nodeData.sessCnt
    },
    timeString () {
      return getTimeString(this.nodeData.sessTime / 1000)
    }
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    getPercentage (value) {
      return (value || 0).toFixed(1) + '%'
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-targeting-values {
  position: absolute;
  left: 50%;
  top: 100%;
  min-width: 100px;
  text-align: center;
  padding-right: 2px;
  box-sizing: border-box;
  transform: translateX(-50%);
  pointer-events: none;

  &.is-only-one-value .item {
    display: inline-block;
  }

  .item {
    position: relative;
    height: 20px;
    font-size: 12px;
    font-weight: 500;
    color: #008299;
    line-height: 20px;
    text-align: left;
    white-space: nowrap;
    margin-top: 1px;
    padding-left: 22px;
    display: block;

    &:first-child {
      margin-top: 5px;
    }

    &.dropoff {
      color: #ff4a00;
    }

    &.nullity {
      color: #888;
    }

    &.refresh {
      color: #0074ff;
    }

    &.duration {
      color: #4b8f0d;
    }
    &.invalid-value {
      color: #2f2f2f;
    }
    .icon {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>
